export default "__VITE_ASSET__Clf4RAZo__"